export default __webpack_public_path__ + "static/media/btn_yacuentocon_movil.fe6464b1.png";